import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'planoplan-ui-kit/core/hooks/useMediaQuery';
import { handleClickDownload, downloadPlanoplanContextHandler, downloadPlanoplanAuxHandler } from '@modules/helper';
import { Points } from '@styles';
import { useTranslations } from '@libs/translations';
import { Button } from 'planoplan-ui-kit/core/button';
import { ButtonSelector } from 'planoplan-ui-kit/core/buttonSelector';
import { getOsData } from '@libs';
import { OS_MAC_SILICON_EN, OS_MAC_SILICON_RU } from '@constants';

export const DownloadButton = () => {
  const isTabletPortrait = useMediaQuery(Points.tablet_landscape, { useSSR: true });
  const isDesktopWide = useMediaQuery(Points.laptop_wide, { useSSR: true });
  const translations = useTranslations();
  const { locale } = useSelector((state) => state.settings);
  const { downloadLink, os } = getOsData(locale);
  const [key, setKey] = useState('before');

  useEffect(() => {
    setKey('after');
  }, []);

  return (
    <ButtonCreate>
      {os === 'windows' ? (
        <Button
          key={key}
          theme="primary"
          data-gtm="button_click"
          size={isDesktopWide ? 'L' : isTabletPortrait ? 'M' : 'S'}
          href={downloadLink}
          onClick={handleClickDownload}
          onContextMenu={downloadPlanoplanContextHandler}
          onAuxClick={downloadPlanoplanAuxHandler}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M1 1H11.4289V11.4243H1V1ZM12.5711 1H23V11.4243H12.5711V1ZM1 12.5711H11.4289V23H1V12.5711ZM12.5711 12.5711H23V23H12.5711"
              fill="white"
            />
          </svg>
          {translations.t(`site.navigation.download.windows-fc`)}
        </Button>
      ) : (
        <ButtonSelector
          key={key}
          theme="primary"
          data-gtm="button_click"
          size={isDesktopWide ? 'L' : isTabletPortrait ? 'M' : 'S'}
          textWidth={isTabletPortrait}
          blank={true}
          options={[
            {
              name: translations.t(`site.navigation.download.mac_intel`),
              href: downloadLink,
              onClick: (e) => {
                handleClickDownload(e);
              },
              onContextMenu: (e) => {
                downloadPlanoplanContextHandler(e);
              },
              onAuxClick: (e) => {
                downloadPlanoplanAuxHandler(e);
              },
              target: '_blank',
              isDownloadLink: true,
            },
            {
              name: translations.t(`site.navigation.download.mac_silicone`),
              href: locale === 'ru' ? OS_MAC_SILICON_RU : OS_MAC_SILICON_EN,
              onClick: (e) => {
                handleClickDownload(e);
              },
              onContextMenu: (e) => {
                downloadPlanoplanContextHandler(e);
              },
              onAuxClick: (e) => {
                downloadPlanoplanAuxHandler(e);
              },
              target: '_blank',
              isDownloadLink: true,
            },
          ]}>
          <span className="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
              <path d="M14.0172 10.5555C14.0078 8.95703 14.732 7.75234 16.1945 6.86406C15.3766 5.69219 14.1391 5.04766 12.5078 4.92344C10.9633 4.80156 9.27344 5.82344 8.65469 5.82344C8.00078 5.82344 6.50547 4.96563 5.32891 4.96563C2.90078 5.00313 0.320312 6.90156 0.320312 10.7641C0.320312 11.9055 0.528906 13.0844 0.946094 14.2984C1.50391 15.8969 3.51484 19.8133 5.6125 19.75C6.70937 19.7242 7.48516 18.9719 8.9125 18.9719C10.2977 18.9719 11.0148 19.75 12.2383 19.75C14.3547 19.7195 16.1734 16.1594 16.7031 14.5563C13.8648 13.218 14.0172 10.6375 14.0172 10.5555ZM11.5539 3.40703C12.7422 1.99609 12.6344 0.711719 12.5992 0.25C11.5492 0.310938 10.3352 0.964844 9.64375 1.76875C8.88203 2.63125 8.43437 3.69766 8.53047 4.9C9.66484 4.98672 10.7008 4.40313 11.5539 3.40703Z" />
            </svg>
          </span>
          {translations.t(`site.navigation.download.mac-fc`)}
        </ButtonSelector>
      )}
    </ButtonCreate>
  );
};

const ButtonCreate = styled.div`
  width: fit-content;
  margin: 0 auto;
  flex-shrink: 0;
  z-index: 5;

  @media ${Points.tablet_landscape} {
    width: auto;
    min-width: 250px;
    width: fit-content;

    button span {
      margin-left: 10px;
    }
  }

  svg {
    width: 16px;
    min-width: 16px;
    margin-right: 10px;
    fill: #fff;

    @media ${Points.tablet_landscape} {
      width: 24px;
      min-width: 24px;
    }
  }
`;
